// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"017c5b69","692":"48d8a985"}[chunkId] + ".chunk.js";
};